import PublicHeader from "../components/public/public-header";
import PublicFooter from "../components/public/public-footer";

const PublicLayout = ({ children }) => (
  <div className="gm-public-layout">
    <PublicHeader />
    <main className="gm-public-layout-content">{children}</main>
    <PublicFooter />
  </div>
);

export default PublicLayout;
